import type {
  ArticleCard as ArticleCardType,
  ArticleListItem
} from 'types/capi/shared';

export default function toArticleCard(item: ArticleListItem): ArticleCardType {
  const fallbackImage = item.featured_image ?? item.image;

  const images = item.core_images?.length
    ? item.core_images.map(({ image, ratio }) => ({
        alt: image.alt,
        ratio,
        url: image.url
      }))
    : fallbackImage
      ? [
          {
            alt: fallbackImage.alt,
            ratio: '16:9' as const,
            url: fallbackImage.url
          }
        ]
      : [];

  const publishedAt = item.date?.published ?? item.dates?.published ?? 0;

  return {
    author: {
      name: item.author.name,
      path: item.author.path,
      title: item.author.title
    },
    excerpt: item.excerpt,
    images,
    link: { path: item.path, text: item.title, type: 'internal' },
    published_at: publishedAt,
    section: item.section,
    title: item.title
  };
}
